import { createGTMEvent } from '../../core/ecommerceMapper';
import { normalizeSegment } from '../../core/normalizers';
import type { DocumentEventInput } from './types';

const DEFAULT_FILE_TYPE = 'pdf';

export const createDocumentGAEvent = ({ event, data }: DocumentEventInput) => {
    const { documentName, documentStatus, serviceGroup, fileType, segment } = data;

    return createGTMEvent(event, {
        document_name: documentName,
        document_status: documentStatus,
        segment: normalizeSegment(segment),
        file_type: fileType || DEFAULT_FILE_TYPE,
        service_type: serviceGroup,
    });
};
